import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, GroupService, UserService} from "../services";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import { locale as polish } from './i18n/pl';
import { locale as english } from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {Order} from "../models/order";
import {ReceiptService} from "../services/receipt.service";
import {CardStatsService} from "./service/card-stats.service";
import {CardStats} from "../models/cardStats";

@Component({
    templateUrl: './cardStatsDetails.component.html',
    styleUrls: ['./cardStatsDetails.component.scss']
})
export class CardStatsDetailsComponent implements OnDestroy, OnInit {
    cardUuid: string;
    uuid: string;
    order: Order;
    cardStats: CardStats;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private receiptService: ReceiptService,
        private cardStatsService: CardStatsService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Details');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.cardUuid = this.route.snapshot.params['cardUuid'];
        this.uuid = this.route.snapshot.params['uuid'];
        this.cardStatsService.getByUuid(this.cardUuid, this.uuid).pipe(first())
            .subscribe((cardStats: CardStats) => {
                this.cardStats = cardStats;
            });
    }

    ngOnDestroy(): void {

    }
}
